import React, { useEffect, useState } from "react";
import Sidebar from "../StudentSidebar/Sidebar";
import StudentNavbar from "../StudentNavbar/StudentNavbar";
import { PngImages, SvgImages } from "../../Utils/LocalImages";
import { ImageFilters } from "../../Utils/Enums";
import Image from "../../Components/Reusable/Image";
import SubmitButtonTwo from "../../Components/Reusable/Buttontwo";
import RoutesPath from "../../Utils/RoutesPath";
import { Link, useNavigate } from "react-router-dom";
import StudentDashboardServices from "../../Services/StudentDashboardApiService";
import { handleApiErrors } from "../../Utils/Utils";
import { CirclesWithBar, RotatingLines } from 'react-loader-spinner'; // Import the loader from react-loader-spinner
import CoordinatorApiServices from "../../Services/CoordinatorApiServices";
import { toast } from "react-toastify";
import ApiConstants from "../../Utils/ApiConstant";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
// import { jsPDF } from 'jspdf'; 


const OrderHistory = () => {
    const [orderData, setOrderData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingTwo, setLoadingTwo] = useState(null);
    const [availableDataCount, setAvailableDataCount] = useState(0);
    const [offset, setOffset] = useState(0);
    const [limit] = useState(7);


    const getOrderHistory = async () => {
        setLoading(true); // Set loading true before API call
        try {
            const response = await StudentDashboardServices.getOrderHistory(
                offset,
                limit,
            );
            setOrderData(response.data);
            setAvailableDataCount(response.availableDataCount);
            if (offset != 0 && offset * limit > availableDataCount - 1) {
                setOffset(offset - 1);
            }
        } catch (error) {
            handleApiErrors(error);
        } finally {
            setLoading(false); // Set loading false after API call
        }
    };



    useEffect(() => {
        getOrderHistory();
    }, [offset]);

    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate(RoutesPath.dashboardstudent);
    };
    const invoice = async (orderId) => {
        setLoadingTwo(orderId)
        try {
            const response = await CoordinatorApiServices.invoice(orderId);
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);

            // Open a new window
            const newWindow = window.open('', '_blank');
            if (newWindow) {
                // Write HTML content into new window
                newWindow.document.open();
                newWindow.document.write(`
                          <html>
                              <head>
                                  <title>Learn and Achieve</title>
                                  <style>
                                      body, html { margin: 0; padding: 0; height: 100%; overflow: hidden; }
                                      iframe { width: 100%; height: 100%; border: none; }
                                  </style>
                              </head>
                              <body>
                                  <iframe src="${pdfUrl}" frameborder="0"></iframe>
                              </body>
                          </html>
                      `);
                newWindow.document.close(); // Close the document to finish writing and render content
                const link = document.createElement('a');
                link.href = pdfUrl;
                link.download = `Inv-${orderId}.pdf`; // Set the filename
                document.body.appendChild(link);
                link.click(); // Trigger the download
                document.body.removeChild(link);
                setLoadingTwo(null)
            }

        } catch (error) {
            setLoadingTwo(null)
            handleApiErrors(error);
        }
    };

    const truncateText = (text, charLimit) => {
        if (!text) return "";
        return text.length > charLimit ? text.substring(0, charLimit) + "..." : text;
    };
    const truncatePackageNames = (packages) => {
        if (!packages || packages.length === 0) return "No Order History";

        const packageNames = packages.map((pkg) => pkg.packageName);
        const totalCount = packageNames.length;

        // Return JSX for display
        if (totalCount > 1) {
            return (
                <>
                    <span>{packageNames[0]}...</span>
                    <span style={{ fontWeight: "bold", color: "black"}}>
                        {" "}
                        & {totalCount - 1} more
                    </span>
                </>
            ); 
        }

        return <span>{packageNames[0]}</span>; // Return the first package name if it's the only one
    };
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">Order History</h1>
                    </div>
                    <div className="table_container" style={{ display: "block" }}>
                        {loading ? (
                            <div className="text-center d-flex justify-content-center">
                                <CirclesWithBar
                                    height="80"
                                    width="80"
                                    color="#F6821F"
                                    ariaLabel="bars-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>
                        ) : (
                            <>
                                {orderData.length === 0 ? (
                                    <div className="no-records-container text-center">
                                        <div className="no-record-image">
                                            <Image src={PngImages.no_record} className="img-fluid" />
                                        </div>
                                        <p className="no-records-text sub-large-text-one fw-700 mb-4">No records found</p>
                                        <div className="d-flex justify-content-center">
                                            <SubmitButtonTwo title={"Go to Packages"} className="Package-button mb-4" onclick={handleButtonClick} />
                                        </div>
                                    </div>
                                ) : (
                                    <div className="Tableorderhistory" style={{ overflowX: "auto" }}>
                                        <table
                                            className="table mb-0 mt-3"
                                            id="dtHorizontalExample"
                                            cellSpacing="0"
                                            width="100%"
                                        >
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Sr No.
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Order Id
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "20%" }}>
                                                        Package Name
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "10%" }}>
                                                        Date & Time
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Transaction Id
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Amount
                                                    </th>
                                                    <th scope="col" className="small-medium-text fw-600 blue" style={{ width: "5%" }}>
                                                        Invoice
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg_light">
                                                {orderData.map((item, index) => (
                                                    <tr key={index} className="table_heading">
                                                        <td className="small-medium-text fw-600 " style={{ paddingLeft: '40px' }}>{limit * offset + (index + 1)}</td>
                                                        <td className="small-medium-text fw-600"  >{item.orderId}</td>
                                                        <td className="small-medium-text fw-600 text-capitalize " title={item.packages.map(pkg => pkg.packageName).join(', ')}>
                                                            {/* {truncateText(item.packages.map(pkg => pkg.packageName).join('/ '),50)} */}
                                                            {truncatePackageNames(item.packages)}
                                                        </td>
                                                        <td className="small-medium-text fw-600">{item.date}</td>
                                                        <td className="small-medium-text fw-600">{item.transaction_id}</td>
                                                        <td className="small-medium-text fw-600">{item.amount}</td>
                                                        <td>
                                                            {loadingTwo == item.orderId ? (
                                                                <div className="">
                                                                    <RotatingLines
                                                                        height="25"
                                                                        width="25"
                                                                        strokeColor="#F6821F"
                                                                        ariaLabel="bars-loading"
                                                                        wrapperStyle={{}}
                                                                        wrapperClass=""
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="cursor-pointer" onClick={() => invoice(item.orderId)}><Image src={SvgImages.download_invoice} /></div>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div className="row mt-3 align-items-center parentcustomnavbtn respo-pagination">
                        <div className="col-md-6 col-sm-6 ">     <p className=" small-text fw-500 mb-0" style={{ opacity: '0.5', fontStyle: "italic" }}>
                            {availableDataCount > 0
                                ? `Showing ${Math.min(offset * limit + 1, availableDataCount)} to ${Math.min((offset + 1) * limit, availableDataCount)} of ${availableDataCount} entries`
                                : "Showing No Entries"}</p>
                        </div>
                        <div className="col-md-6 col-sm-6 pagebtnrespo">  {
                            generatePaginationFooter(
                                availableDataCount,
                                limit,
                                offset,
                                setOffset
                            )}</div>

                    </div>
                </div>
            </div>


        </div>
    );
};

export default OrderHistory;
